import { useState } from "react";
import { RiAddLine, RiCloseLine, RiCodeLine } from "react-icons/ri";

const DynamicVariables = ({ variables, onInsert }) => {
  const [showVariables, setShowVariables] = useState(false);
  const [customVariable, setCustomVariable] = useState("");

  const defaultVariables = [
    { name: "first_name", description: "Recipient's first name" },
    { name: "last_name", description: "Recipient's last name" },
    { name: "company_name", description: "Company name" },
    { name: "custom_offer", description: "Personalized offer code" },
    { name: "total_amount", description: "Order total amount" },
    { name: "order_date", description: "Date of order" },
    ...variables,
  ];

  const handleAddCustomVariable = () => {
    if (customVariable.trim()) {
      onInsert(`{${customVariable}}`);
      setCustomVariable("");
      setShowVariables(false);
    }
  };

  return (
    <div className="relative">
      <button
        className="btn btn-secondary flex items-center"
        onClick={() => setShowVariables(!showVariables)}
      >
        <RiCodeLine className="w-5 h-5 mr-2" />
        Insert Variable
      </button>

      {showVariables && (
        <div className="absolute z-10 mt-2 w-72 bg-white rounded-lg shadow-lg border border-secondary-200">
          <div className="p-3 border-b border-secondary-200">
            <div className="flex space-x-2">
              <input
                type="text"
                placeholder="Custom variable name"
                className="input-field text-sm"
                value={customVariable}
                onChange={(e) => setCustomVariable(e.target.value)}
                onKeyPress={(e) =>
                  e.key === "Enter" && handleAddCustomVariable()
                }
              />
              <button
                className="btn btn-primary p-2"
                onClick={handleAddCustomVariable}
              >
                <RiAddLine className="w-4 h-4" />
              </button>
            </div>
          </div>
          <div className="max-h-60 overflow-y-auto">
            {defaultVariables.map((variable) => (
              <button
                key={variable.name}
                className="w-full px-4 py-2 text-left hover:bg-secondary-50 flex items-center justify-between group"
                onClick={() => {
                  onInsert(`{${variable.name}}`);
                  setShowVariables(false);
                }}
              >
                <div>
                  <span className="text-primary-500">{`{${variable.name}}`}</span>
                  <p className="text-xs text-secondary-500">
                    {variable.description}
                  </p>
                </div>
                <RiAddLine className="w-4 h-4 opacity-0 group-hover:opacity-100 text-primary-500" />
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default DynamicVariables;
